import { takeEvery, call, fork, put } from 'redux-saga/effects';
import * as apiAgent from 'src/redux/api/agent';
import {
  updateAgency as updateAgencyCall,
  createAgency as createAgencyCall,
} from 'src/redux/api/agency';
import {
  agencyActions,
  navigationActions,
  loadingActions,
} from 'src/redux/actions';

function* createAgency(action) {
  try {
    yield put(agencyActions.setValidationErrors(null));
    const { data: agency } = yield call(createAgencyCall, {
      agency: action.payload.agency,
    });

    yield put(agencyActions.saveAgency(agency));
    yield put(navigationActions.navigateForward(agency, action.formName));
  } catch (error) {
    if (error && error.response && error.response.status === 422) {
      yield put(agencyActions.setValidationErrors(error.response.data));
    }
  }
}

function* updateAgency(action) {
  try {
    yield put(loadingActions.showLoader());
    yield put(agencyActions.setValidationErrors(null));
    const { data: agency } = yield call(updateAgencyCall, {
      agency: action.payload.agency,
    });
    yield put(agencyActions.saveAgency(agency));

    if (!action.navigationDisabled)
      yield put(navigationActions.navigateForward(agency, action.formName));
    yield put(loadingActions.hideLoader());
  } catch (error) {
    yield put(loadingActions.hideLoader());

    if (error && error.response && error.response.status === 422) {
      yield put(agencyActions.setValidationErrors(error.response.data));
    }

    if (error && error.response && error.response.status === 301) {
      window.location.replace(error.response.data.url);
    }
  }
}

function* watchAgencyRequests() {
  yield takeEvery(agencyActions.types.CREATE_AGENCY_EFFECT, createAgency);
  yield takeEvery(agencyActions.types.UPDATE_AGENCY_EFFECT, updateAgency);
}

function* addNewAgent(action) {
  try {
    yield put(agencyActions.setValidationErrors(null));

    const { data: agent } = yield call(
      apiAgent.createAgent,
      action.payload.agent,
    );

    yield put(agencyActions.saveNewAgent(agent));

    yield put(navigationActions.navigateForward(agent.id));
  } catch (error) {
    if (error && error.response && error.response.status === 422) {
      yield put(agencyActions.setValidationErrors(error.response.data));
    }
  }
}

function* updateAgent(action) {
  try {
    yield put(agencyActions.setValidationErrors(null));

    const { data: agent } = yield call(
      apiAgent.updateAgent,
      action.payload.agent,
    );

    yield put(agencyActions.saveUpdatedAgent(agent));
    yield put(navigationActions.navigateForward(action.payload.agent.id));
  } catch (error) {
    if (error && error.response && error.response.status === 422) {
      yield put(agencyActions.setValidationErrors(error.response.data));
    }
  }
}

function* deleteAgent(action) {
  try {
    yield put(loadingActions.showLoader());
    yield call(apiAgent.deleteAgent, action.payload.agent);
    yield put(agencyActions.saveAgentDeletion(action.payload.agent));
    yield put(loadingActions.hideLoader());
  } catch (error) {
    yield put(loadingActions.hideLoader());
    console.error(error);
  }
}

function* watchAgentRequest() {
  yield takeEvery(agencyActions.types.ADD_NEW_AGENT_EFFECT, addNewAgent);
  yield takeEvery(agencyActions.types.UPDATE_AGENT_EFFECT, updateAgent);
  yield takeEvery(agencyActions.types.DELETE_AGENT_EFFECT, deleteAgent);
}

const agencySagas = [fork(watchAgencyRequests), fork(watchAgentRequest)];

export default agencySagas;
